import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1536 192V64Q1536 38 1517.0 19.0Q1498 0 1472 0H64Q38 0 19.0 19.0Q0 38 0 64V192Q0 218 19.0 237.0Q38 256 64 256H1472Q1498 256 1517.0 237.0Q1536 218 1536 192ZM1536 704V576Q1536 550 1517.0 531.0Q1498 512 1472 512H64Q38 512 19.0 531.0Q0 550 0 576V704Q0 730 19.0 749.0Q38 768 64 768H1472Q1498 768 1517.0 749.0Q1536 730 1536 704ZM1536 1216V1088Q1536 1062 1517.0 1043.0Q1498 1024 1472 1024H64Q38 1024 19.0 1043.0Q0 1062 0 1088V1216Q0 1242 19.0 1261.0Q38 1280 64 1280H1472Q1498 1280 1517.0 1261.0Q1536 1242 1536 1216Z"
	})
});
export default SvgMenu;
